// extracted by mini-css-extract-plugin
module.exports = {"container":"property-detail_container__3P7DH","sep":"property-detail_sep__2A8zw","tab":"property-detail_tab__QMjfS"};